const vars = {
	breakpoint: {
		mobile: 500,
		tablet: 700,
		laptop: 1000,
		desktop: 1200,
		largest: 1400,
	},
};

export { vars };
